var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePosterCreationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_892_9260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.30115 15.5434L4.40563 5.04411C4.40752 4.8471 4.44821 4.65238 4.52537 4.4711C4.60253 4.28981 4.71465 4.1255 4.85532 3.98755C4.99599 3.8496 5.16246 3.74072 5.34522 3.66712C5.52798 3.59352 5.72345 3.55664 5.92047 3.5586L14.9204 3.64903C15.3182 3.65305 15.6981 3.81492 15.9765 4.09902C16.255 4.38313 16.4092 4.76621 16.4052 5.16399L16.3007 15.6632C16.2988 15.8602 16.2581 16.055 16.181 16.2362C16.1038 16.4175 15.9917 16.5818 15.851 16.7198C15.7103 16.8577 15.5439 16.9666 15.3611 17.0402C15.1783 17.1138 14.9829 17.1507 14.7859 17.1487L5.78593 17.0583C5.38814 17.0543 5.00824 16.8924 4.7298 16.6083C4.45135 16.3242 4.29717 15.9411 4.30115 15.5434Z",
    stroke: "#2563EB",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39047 6.57371L13.3905 6.63321M7.36028 9.57344L13.3605 9.63368M7.33084 12.573L11.0807 12.6109",
    stroke: "#2563EB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_892_9260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 2.94922) rotate(-9.42979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePosterCreationIcon);
export default __webpack_public_path__ + "static/media/active-poster-creation-icon.3c9e9ce87d1aebb6a11265d803646ca7.svg";
export { ForwardRef as ReactComponent };